export default __webpack_public_path__ + "static/media/dd2.b40fbd39.jpg";